import * as React from "react";
const SvgNewProcessAgentIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 40 40", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 20, cy: 20, r: 20, fill: "#ebdeff", style: {
  fill: "#ebdeff",
  fill: "color(display-p3 .9235 .8708 1)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { stroke: "#504f87", strokeLinecap: "round", strokeLinejoin: "round", d: "M14.5 20h11M20 14.5v11", style: {
  stroke: "#504f87",
  stroke: "color(display-p3 .3137 .3098 .5294)",
  strokeOpacity: 1
} }));
export default SvgNewProcessAgentIcon;
